export const CONSTANTS = {
	DELAY: 200,
	SUPPORT_MAIL_ADDRESS: 'support@liftapp.ai',
	SUPPORT_URL: 'https://support.liftapp.ai/hc/en-us',
	APPLE_CLIENT_ID: 'com.liftstory.me.signin',

	// GDPR regions
	COOKIES_ACCESS_REGION: [
		'AT',
		'BE',
		'BG',
		'HR',
		'CY',
		'CZ',
		'DK',
		'EE',
		'FI',
		'FR',
		'DE',
		'GR',
		'EL',
		'HU',
		'IE',
		'IT',
		'LV',
		'LT',
		'LU',
		'MT',
		'NL',
		'PL',
		'PT',
		'RO',
		'SK',
		'SI',
		'ES',
		'SE',
		'GB',
		'IM',
		'UK',
		// 'UA', // INFO: uncomment only for dev
	],
	// CCPA — applies to all US states
	COOKIES_ACCESS_CCPA_COUNTRY: 'US',
} as const;

export const LOCAL_STORAGE_KEYS = {
	RND_FB_PIXEL: 'cookies_rnd_fb_pixel',
};

export const LANGUAGE_NAMES: Record<string, string> = {
	en: 'English',
	es: 'Español',
	pt: 'Português',
	de: 'Deutsch',
	it: 'Italiano',
	fr: 'Français',
	pl: 'Polski',
	tr: 'Türkçe',
	id: 'Bahasa Indonesia',
	hi: 'हिन्दी',
	vi: 'Tiếng Việt',
	th: 'ไทย',
	nl: 'Nederlands',
};

export const COUNTRY_FLAGS: Record<string, string> = {
	en: '🇬🇧',
	es: '🇪🇸',
	pt: '🇵🇹',
	de: '🇩🇪',
	it: '🇮🇹',
	fr: '🇫🇷',
	pl: '🇵🇱',
	tr: '🇹🇷',
	id: '🇮🇩',
	hi: '🇮🇳',
	vi: '🇻🇳',
	th: '🇹🇭',
	nl: '🇳🇱',
};
